import { render, staticRenderFns } from "./WootReports.vue?vue&type=template&id=1487ba56&"
import script from "./WootReports.vue?vue&type=script&lang=js&"
export * from "./WootReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1487ba56')) {
      api.createRecord('1487ba56', component.options)
    } else {
      api.reload('1487ba56', component.options)
    }
    module.hot.accept("./WootReports.vue?vue&type=template&id=1487ba56&", function () {
      api.rerender('1487ba56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/reports/components/WootReports.vue"
export default component.exports